<p-dialog [(visible)]="balanceOverdraftDialogVisible" [resizable]="false" [draggable]="true" [modal]="true">
  <ng-template #header>
    {{ 'tradingBusiness.dialog.header.balanceOverdraft' | translate }}
  </ng-template>
  {{ 'tradingBusiness.dialog.body.balanceOverdraft' | translate }}
  <ng-template #footer>
    <p-button label="{{'common.cancel' | translate}}" severity="secondary" variant="outlined" icon="pi pi-times"
              (onClick)="onCancel()" />
    <p-button label="{{'common.release' | translate}}" severity="primary" variant="outlined" icon="pi pi-check-square"
              (onClick)="processExecuteAfterBalanceOverdraft()" />
  </ng-template>
</p-dialog>
